import { v4 as uuidv4 } from 'uuid';

export const folderTemplateItemsToFolders = (folderTemplateItems, parentFolder = null) => {
  const clientIdsByTemplateId = new Map(folderTemplateItems.map((folder) => [String(folder.id), uuidv4()]));

  return folderTemplateItems.map((folder) => {
    const parentClientId =
      folder.parentId == null
        ? parentFolder?.type === 'new'
          ? parentFolder.clientId
          : null
        : clientIdsByTemplateId.get(String(folder.parentId)) ?? null;

    return {
      clientId: clientIdsByTemplateId.get(String(folder.id)),
      name: folder.name,
      color: folder.color,
      protected: folder.protected,
      ...(folder.parentId == null && parentFolder?.type === 'saved'
        ? { parentId: parentFolder.id }
        : { parentClientId }),
    };
  });
};
